import { useEffect } from "react";
import { clientConnector } from "@games/socket-client";
import { logger } from "@games/logger-client";
import { extendSocketWithUser } from "./socket/user";
import { extendSocketWithRoom } from "./socket/room";
import { extendSocketWithSettings } from "./socket/globalSettings";
import { extendSocketWithStats } from "./socket/stats";
import { extendSocketWithChat } from "./socket/chat";
import { extendSocketWithGame } from "./socket/game";
import { extendSocketWithBattleInitData } from "./socket/battleInitData";

/** Настраивает clientConnector для страницы теста (без Unity). */
export function useClientConnectorSetup(accessToken: string) {
  useEffect(() => {
    const socketUrl =
      process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_SOCKET_URL ||
          `https://${window.location.hostname}`
        : window.location.origin; // 3000 → proxy → 3999

    const socketParams = {
      server: socketUrl,
      msgPack: true,
      params: {
        auth: { token: accessToken },
        transports: ["polling", "websocket"],
      },
    };
    window.socketParams = socketParams;
    window.clientConnector = clientConnector;

    extendSocketWithSettings();
    extendSocketWithStats();
    extendSocketWithUser();
    extendSocketWithRoom();
    extendSocketWithChat();
    extendSocketWithGame();
    extendSocketWithBattleInitData();
    logger.socket("Socket factory created and exposed to window.clientConnector");

    clientConnector.initialize({}, socketParams);

    return () => {
      if (window.clientConnector?.isInitialized()) {
        window.clientConnector.destroy();
      }
      if (window.clientConnector) {
        delete window.clientConnector;
      }
    };
  }, [accessToken]);
}
